import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalConnectError extends StripeTerminalError {
  constructor(message: unknown, code?: number | string) {
    super(message, code);
    this.name = 'StripeTerminalConnectError';
  }
}
